'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VehicleInsurer;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _input = require('../components/input');
var _input2 = _interopRequireDefault(_input);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function VehicleInsurer(props) {
  return _react2.default.createElement(_input2.default, {
    name: 'mainInsurer',
    label: 'Which insurance company currently provides cover on this car? (e.g. Direct Line)',
    helpText: 'Main insurance needs to be in place for this insurance to be valid.'
  });
}